import { Pages } from '.generated/Project.CW.model';
import type { Article, WithContext } from 'schema-dts';
import { format, parseISO } from 'date-fns';
import { stripHtmlTags } from 'lib/utils/string-utils';

export const buildBlogDetailJsonLd = (
  data: Pages.BlogDetailPage,
  pageUrl: string
): WithContext<Article> => {
  const authorName = data.fields?.author?.name as string | undefined;
  const blogTagsSource =
    (data.fields?.blogTags as { value?: unknown })?.value ?? data.fields?.blogTags ?? [];
  const blogDate = data.fields?.date?.value
    ? format(parseISO(data.fields.date.value), 'yyyy-MM-dd')
    : undefined;

  const aboutTags: { '@type': 'Specialty'; name: string }[] = Array.isArray(blogTagsSource)
    ? blogTagsSource
        .map((tag: { name?: string }) => ({ '@type': 'Specialty', name: tag?.name }))
        .filter(
          (specialty): specialty is { '@type': 'Specialty'; name: string } => !!specialty.name
        )
    : [];

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: data.fields?.blogPostTitle?.value,
    url: pageUrl,
    description: stripHtmlTags(data.fields?.Description?.value),
    datePublished: blogDate,
    author: {
      '@type': 'Person',
      name: authorName,
    },
    about: aboutTags,
  };
};
